import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    templates: [],
};

const templateSlice = createSlice({
    name: "template",
    initialState: initialState,
    reducers: {
        loadTemplatesSuccess(state, action) {
            return { ...state, templates: action.payload };
        },
        updateTemplateSuccess(state, action) {
            const saved = action.payload;
            const templates = [...(state.templates || [])];
            const idx = templates.findIndex((t) => t.id === saved.id);
            if (idx >= 0) templates[idx] = saved;
            else templates.push(saved);
            return { ...state, templates };
        },
        deleteTemplateSuccess(state, action) {
            const id = action.payload;
            return { ...state, templates: (state.templates || []).filter((t) => t.id !== id) };
        },
    },
});

export const { loadTemplatesSuccess, updateTemplateSuccess, deleteTemplateSuccess } = templateSlice.actions;
export default templateSlice.reducer;

export const fetchTemplates = () => async (dispatch) => {
    fetch("/api/templates")
        .then((response) => {
            if (response.ok) {
                response.json().then((json) => dispatch(loadTemplatesSuccess(json)));
            }
        })
        .catch((error) => console.log(error));
};

const getTemplateEndpoint = (type) => {
    switch (type) {
        case "INCOME":
            return "/api/templates/income";
        case "EXPENSE":
            return "/api/templates/expense";
        case "TRANSFER":
            return "/api/templates/transfer";
        default:
            return "/api/templates/expense";
    }
};

export const saveTemplate = (template, onSuccess) => async (dispatch) => {
    const type = template.type || "EXPENSE";
    const url = getTemplateEndpoint(type);
    fetch(url, {
        method: "PUT",
        body: JSON.stringify(template),
        headers: { "Content-Type": "application/json" },
    })
        .then((response) => {
            if (response.ok) {
                response.json().then((json) => {
                    dispatch(updateTemplateSuccess(json));
                    if (onSuccess) onSuccess();
                });
            }
        })
        .catch((error) => console.log(error));
};

export const deleteTemplate = (template, onSuccess) => async (dispatch) => {
    fetch("/api/templates?id=" + template.id, { method: "DELETE" })
        .then((response) => {
            if (response.ok) {
                dispatch(deleteTemplateSuccess(template.id));
                if (onSuccess) onSuccess();
            }
        })
        .catch((error) => console.log(error));
};

export const selectAllTemplates = (state) => state.templateSlice.templates;
